import { render, staticRenderFns } from "./OrderCardCompact.vue?vue&type=template&id=3bdc0a20&scoped=true&"
import script from "./OrderCardCompact.vue?vue&type=script&lang=js&"
export * from "./OrderCardCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdc0a20",
  null
  
)

export default component.exports